<ion-popover #popoverMonthDate [trigger]="'trigger_'+this.formName" side="bottom" alignment="center">
    <ng-template>    
        <ion-label>{{this.labelInput}}</ion-label>
        <ion-datetime #monthDate presentation="month-year" value="{{this.formGroupDirective.form.controls[this.formName].value | marvDateToString: 'ISO8601'}}" (ionChange)="this.selectMonth($event)">
            <ion-buttons slot="buttons">                
                <ion-button color="primary" fill="clear" (click)="monthDate.confirm()">{{'VALIDATE' | translate}}</ion-button>
                <ion-button color="primary" fill="clear" (click)="this.closeMonthPicker()">{{'CANCEL' | translate}}</ion-button>
            </ion-buttons>
        </ion-datetime>
    </ng-template>
</ion-popover>

<div 
    class="marv_select_month"
    [class.no_margin]="this.noMargin"   
    [class.disabled]="this.disabled" 
    >
    
    <div class="marv_select_month_trigger" [id]="(!this.disabled ? 'trigger_'+this.formName : '')">
        @if(this.withSpeechToText){
            <ion-icon class="marv_input_icon_speech" name="mic-outline" (click)="this.speechToText($event)"></ion-icon>
        } 
    </div>
    
    @if(this.iconInput !== ''){
        <ion-icon class="marv_select_month_icon_prefix" [name]="this.iconInput"></ion-icon>
    }
    
    @if(this.isRequired){
        <div class="marv_input_required">*</div>
    }
    
    @if(this.fixedLabel){
        <div class="marv_input_fixed_label">{{this.labelInput}}</div>
    }
    
    <input 
        type="text" 
        [placeholder]="(!this.fixedLabel ? this.labelInput : '')"
        autocomplete="off"
        value="{{this.formGroupDirective.form.controls[this.formName].value | marvDateToString: 'MMMM YYYY'}}"        
        disabled
        />    
    
    <input type="hidden" [name]="this.formName" [formControlName]="this.formName" />    
</div>

@if(this.errorText !== '' 
    && this.formGroupDirective.form.controls[this.formName] 
    && this.formGroupDirective.form.controls[this.formName].touched 
    && this.formGroupDirective.form.controls[this.formName].errors){
    <div class="marv_input_error">{{this.errorText}}</div>
}

@if(this.withSpeechToText){
    <marv-speech-to-text #marvSpeechToText (onDidDismiss)="this.onDismissSpeechToText($event)"/>
}